module.exports = __webpack_public_path__ + "img/ics_o_globe.64fc2419.svg";